<div class="container">
  <div class="layout-row-wrap responsive-column gap-2percent">
    <div class="flex-48">
      <mat-card class="layout-column">
        <mat-card-content class="layout-column">
          @if (!(officeData === undefined || officeData === null)) {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
              <mat-select [formControl]="officeSelector">
                @for (office of officeData; track office) {
                  <mat-option [value]="office.id">
                    {{ office.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (!(employeeData === undefined || employeeData === null)) {
            <mat-form-field>
              <mat-label>{{ employeeData.length ? 'Officer' : 'No Associated Officers' }}</mat-label>
              <mat-select [formControl]="employeeSelector">
                @for (employee of employeeData; track employee) {
                  <mat-option [value]="employee.id">
                    {{ employee.displayName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (!(centerData === undefined || centerData === null)) {
            <mat-form-field>
              <mat-label>{{ centerData.length ? 'Center' : 'No Associated Centers' }}</mat-label>
              <mat-select [formControl]="centerSelector">
                @for (center of centerData; track center) {
                  <mat-option [value]="center.id">
                    {{ center.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (!(groupData === undefined || groupData === null)) {
            <mat-form-field>
              <mat-label>{{ groupData.length ? 'Group' : 'No Associated Groups' }}</mat-label>
              <mat-select [formControl]="groupSelector">
                @for (group of groupData; track group) {
                  <mat-option [value]="group.id">
                    {{ group.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (!(clientData === undefined || clientData === null)) {
            <mat-form-field>
              <mat-label>{{ clientData.length ? 'Client' : 'No Associated Clients' }}</mat-label>
              <mat-select [formControl]="clientSelector">
                @for (client of clientData; track client) {
                  <mat-option [value]="client.id">
                    {{ client.displayName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </mat-card-content>
      </mat-card>
    </div>

    <div class="flex-48">
      @if (selectedItem) {
        <mat-card class="layout-column">
          @if (selectedItem.itemType === 'office') {
            <LOSx-office-navigation
              [officeData]="selectedItem"
              [employeeData]="employeeData"
            ></LOSx-office-navigation>
          }
          @if (selectedItem.itemType === 'employee') {
            <LOSx-staff-navigation [employeeData]="selectedItem" [centerData]="centerData"></LOSx-staff-navigation>
          }
          @if (selectedItem.itemType === 'center') {
            <LOSx-center-navigation
              [centerData]="selectedItem"
              [groupData]="groupData"
              [centerAccountsData]="selectedItemAccounts"
              [centerSummaryData]="selectedItemSummary"
            ></LOSx-center-navigation>
          }
          @if (selectedItem.itemType === 'group') {
            <LOSx-group-navigation
              [groupData]="selectedItem"
              [clientData]="clientData"
              [groupAccountsData]="selectedItemAccounts"
            ></LOSx-group-navigation>
          }
          @if (selectedItem.itemType === 'client') {
            <LOSx-client-navigation
              [clientData]="selectedItem"
              [clientAccountsData]="selectedItemAccounts"
            ></LOSx-client-navigation>
          }
        </mat-card>
      }
    </div>
  </div>
</div>
